// extracted by mini-css-extract-plugin
export var wrapper = "interface-section-module--wrapper--B9n+Q";
export var interfaceImg = "interface-section-module--interface-img---2bve";